var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activity"},[_c('div',{staticClass:"container"},[_c('ActivityRegister',{attrs:{"data":this.listData},on:{"statusClick":_vm.handleStatusClick}})],1),_c('Prompt',{ref:"prompt"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }